<template>
  <div>
    <table>
      <template v-for="(item, index) in items">
        <tr :key="`timeline-row-${index}`">
          <td>
            <slot name="label" v-bind:item="item" v-bind:value="item.label">
              <div class="text-right">
                <custom-badge :variant="item.variant" class="">
                  {{ item.label }}
                </custom-badge>
              </div>
            </slot>
          </td>
          <td class="position-relative py-3">
            <i
              :class="`${item.dividerIcon || 'ri-circle-line'} ${
                item.dividerIconClass
              }`"
            ></i>
            <div v-if="index + 1 < items.length" class="line-timeline"></div>
          </td>
          <td>
            <slot name="text" v-bind:item="item" v-bind:value="item.text">
              {{ item.text }}
            </slot>
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
export default {
  name: "NurseryFeTimeline",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.line-timeline {
  position: absolute;
  top: calc(100% - 13px);
  left: 50%;
  height: calc(100% - 20px);
  min-height: 10px;
  transform: translateX(-50%);
  width: 3px;
  border-radius: 8px;
  background-color: #e5eaee;
}
</style>


// WEBPACK FOOTER //
// src/base/component/timeline.vue